import type { FieldDefinition, Sort } from "@estelle/domain";

/**
 * Recent's order when nobody has chosen one: newest change first. Shared by the
 * screen and its export, because an export that left it out came out in the
 * order the folders happen to be walked in, under a list that was newest-first.
 */
export const RECENT_DEFAULT_SORT: Sort[] = [
  { column: "updatedAt", direction: "desc" },
];

/**
 * What Recent offers the filter builder, the column chooser and the sort
 * control.
 *
 * `folderPath` is declared as plain text rather than `enum`: the visible
 * folder set changes as grants are edited, and a fixed `options` list would
 * drift from it immediately. `contains`/`is` already answer "which folder"
 * well enough for a handbook this size.
 */
export const RECENT_FIELDS: FieldDefinition[] = [
  { name: "title", label: "Page", type: "text", sortable: true },
  { name: "folderPath", label: "Folder", type: "text", sortable: true },
  {
    name: "updatedAt",
    label: "Last changed",
    type: "datetime",
    sortable: true,
  },
  { name: "authorName", label: "Changed by", type: "text", sortable: true },
  { name: "message", label: "Change message", type: "text" },
];

/**
 * Search's vocabulary — the same shape as Recent, plus the excerpt that
 * shows why a row matched.
 *
 * `context` is built from the search term, not stored data: re-running it
 * through a filter or a sort would compare yesterday's excerpt against
 * today's term, so both are declared `false` rather than silently doing
 * nothing when someone clicks the column header.
 */
export const SEARCH_FIELDS: FieldDefinition[] = [
  { name: "title", label: "Page", type: "text", sortable: true },
  { name: "folderPath", label: "Folder", type: "text", sortable: true },
  {
    name: "updatedAt",
    label: "Last changed",
    type: "datetime",
    sortable: true,
  },
  {
    name: "context",
    label: "Match",
    type: "text",
    filterable: false,
    sortable: false,
  },
];
